import React, { useState } from 'react'
import Entry from '../assets/icons/entry.svg'
import Guidelines from '../assets/icons/guidelines.svg'
import Exam from '../assets/icons/exam.svg'
import Questions from '../assets/icons/questions.svg'
import Time from '../assets/icons/time-circle.svg'
import DetailsCard from '../components/DetailsCard';
import Gallery from '../components/modals/Gallery';
import GalleryModal from '../components/modals/GalleryModal';
import entry1 from '../assets/images/howTo/entry1.png'
import entry2 from '../assets/images/howTo/entry2.png'
import entry3 from '../assets/images/howTo/entry3.png'
import entry4 from '../assets/images/howTo/entry4.png'
import guidelines1 from '../assets/images/howTo/guidelines1.png'
import guidelines2 from '../assets/images/howTo/guidelines2.png'
import org1 from '../assets/images/howTo/org1.png'
import org2 from '../assets/images/howTo/org2.png'
import org3 from '../assets/images/howTo/org3.png'
import quest1 from '../assets/images/howTo/quest1.png'
import quest2 from '../assets/images/howTo/quest2.png'
import quest3 from '../assets/images/howTo/quest3.png'
import quest4 from '../assets/images/howTo/quest4.png'
import quest5 from '../assets/images/howTo/quest5.png'
import quest6 from '../assets/images/howTo/quest6.png'
import time1 from '../assets/images/howTo/time1.png'
import time2 from '../assets/images/howTo/time2.png'
import time3 from '../assets/images/howTo/time3.png'
import time4 from '../assets/images/howTo/time4.png'
import time5 from '../assets/images/howTo/time5.png'
import time6 from '../assets/images/howTo/time6.png'
import title_icon1 from '../assets/icons/galleryIcon1.svg'
import title_icon2 from '../assets/icons/galleryicon2.svg'
import title_icon3 from '../assets/icons/galleryIcon3.svg'
import title_icon4 from '../assets/icons/galleryIcon4.svg'
import title_icon5 from '../assets/icons/galleryIcon5.svg'
import DashboardLayout from './DashboardLayout'





const Help = () => {
  const [modal, setModal] = useState(false);
  const [data, setData] = useState();


  const howTo = [
    {
      id: 1,
      name: 'About entry requirements',
      icon: Entry,
      alt: 'entry_icon',
      title: 'About entry requirements',
      title_icon: title_icon1,
      images : [
        {
          id: 1,
          img: entry1,
        },
        {
          id: 2,
          img: entry2,
        },
        {
          id: 3,
          img: entry3,
        },
        {
          id: 4,
          img: entry4,
        },
      ],
      img_alt : 'entry_image'
    },
    {
      id: 2,
      name: 'General guidelines',
      icon: Guidelines,
      alt: 'guidelines_icon',
      title: 'General guidelines',
      title_icon: title_icon2,
      images : [
        {
          id: 1,
          img: guidelines1,
        },
        {
          id: 2,
          img: guidelines2,
        }
      ],
      img_alt : 'entry_image'
    },
    {
      id: 3,
      name: 'Organisation for exam',
      icon: Exam,
      alt: 'exam_icon',
      title: 'Organisation for exam',
      title_icon: title_icon3,
      images : [
        {
          id: 1,
          img: org1,
        },
        {
          id: 2,
          img: org2,
        },
        {
          id: 3,
          img: org3,
        },
      ],
      img_alt : 'entry_image'
    },
    {
      id: 4,
      name: 'Answering questions',
      icon: Questions,
      alt: 'question_icon',
      title: 'Answering  multiple choice questions',
      title_icon: title_icon4,
      images : [
        {
          id: 1,
          img: quest1,
        },
        {
          id: 2,
          img: quest2,
        },
        {
          id: 3,
          img: quest3,
        },
        {
          id: 4,
          img: quest4,
        },
        {
          id: 5,
          img: quest5,
        },
        {
          id: 6,
          img: quest6,
        },
      ],
      img_alt : 'entry_image'
    },
    {
      id: 5,
      name: 'Managing exam time',
      icon: Time,
      alt: 'exam_time_icon',
      title: 'Managing exam time',
      title_icon: title_icon5,
      images : [
        {
          id: 1,
          img: time1,
        },
        {
          id: 2,
          img: time2,
        },
        {
          id: 3,
          img: time3,
        },
        {
          id: 4,
          img: time4,
        },
        {
          id: 5,
          img: time5,
        },
        {
          id: 6,
          img: time6,
        },
      ],
      img_alt : 'entry_image'
    },
  ]


  const handleModal = (item) => {
    setModal(item)
    setData(item)
  }

  return (
    <DashboardLayout help="How to" childTab={11} animated={true}>
    <div className='flex flex-col items-center justify-center w-full px-5 pb-7 mt-10 md:px-6 md:mt-5 lg:relative lg:px-7 lg:mt-3 xl:px-10 xl:pb-10'>

        {/*TITLE*/}
        <div className='flex items-center justify-between w-full mt-6 xl:mt-7'>
           <p className='text-[12px] font-semibold text-[#53545C] md:text-[13px] xl:text-base'>
                HOW TO
           </p>
        </div>


        {/*SYLLABUS CARDS*/}
        <div className='flex items-center justify-between w-full flex-wrap mt-6 md:justify-start'>
            {howTo.map((item) => {
              return(
                <DetailsCard onClick={()=>handleModal(item)} key={item.id} data={item} index={item.id} />
              )
            })}
        </div>



             {/*MODALS*/}
        {modal &&
        <GalleryModal onClick={()=>setModal(false)}>
            <Gallery data={data} setModal={setModal} />
        </GalleryModal>
        }


    </div>
    </DashboardLayout>
  )
}

export default Help
